import produce from 'immer';

import { createKeyInTransform } from 'Lib/persist/transforms';
import type { Action } from 'Lib/reduxType';

import { getCommonResetAction } from 'Store/commonActions';

import {
  SET_INTRO_PRICE_NOTIFICATION_SHOWN,
  SET_INTRO_PRICE_PAYWALL_VIEWED_SUCCESS,
} from './constants';
import initialState from './initialState';
import type { IntroPricingState } from './types';

export const reducer = produce<IntroPricingState, [Action]>((draft, action) => {
  switch (action.type) {
    case SET_INTRO_PRICE_PAYWALL_VIEWED_SUCCESS: {
      const introPriceData = action.payload?.result;
      draft.expiresAt = introPriceData?.expiresAt ?? 0;
      draft.viewedAt = introPriceData?.viewedAt ?? 0;
      break;
    }
    case SET_INTRO_PRICE_NOTIFICATION_SHOWN: {
      draft.notificationShown = true;
      break;
    }
    case getCommonResetAction(action.type):
      return initialState;
    default:
      break;
  }
}, initialState);

export const persistConfig = {
  transforms: [createKeyInTransform(['viewedAt'])],
  version: 1,
};
